import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import {withRFSToken} from '../../Services/axios.js'; // Ensure this path is correct
import { GETTYPECODE, GETOWNERCODE, GETCONDITIONCODE, GETDAMAGETYPE, GETDESTINATION, ULDREPAIRUPDATE, ULDALLUPDATE, GETCONTENTCODE, STTRUPDATE, ULDEXISTS } from '../../Utils/conts';

const actionTypes = ['RFS', 'ULD'];
let keyType = null;
// Loop through the actionTypes array
for (let i = 0; i < localStorage.length; i++) {
  const key = localStorage.key(i);
  // Check if the current key matches any of the action keyTypes
  if (actionTypes.includes(key)) {
    keyType = key;
    break;
  }
}
const apiUrl = process.env.REACT_APP_RFS_URL;

export const fetchTypeCode = createAsyncThunk('GETTYPECODE', async () => {
  const response = await fetch(`${apiUrl}${GETTYPECODE}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem(keyType)}`
    },
    body: JSON.stringify({})
  });
  const data = await response.json();
  return data.response_data.map(item => ({
    value: item.uld_typecode,
    label: item.uld_typecode,
  }));
});

export const fetchContentCode = createAsyncThunk('GETCONTENTCODE', async () => {
  const response = await fetch(`${process.env.REACT_APP_RFS_URL}${GETCONTENTCODE}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem(keyType)}`
    },
    body: JSON.stringify({})
  });
  return response.data.response_data;
});

export const fetchOwnerCode = createAsyncThunk('GETOWNERCODE', async () => {
  const response = await fetch(`${process.env.REACT_APP_RFS_URL}${GETOWNERCODE}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem(keyType)}`
    },
    body: JSON.stringify({})
  });
  return response.data.response_data.map(item => ({
    value: item.IATA,
    label: item.IATA,
  }));
});

export const fetchCondCode = createAsyncThunk('GETCONDITIONCODE', async () => {
  const response = await fetch(`${process.env.REACT_APP_RFS_URL}${GETCONDITIONCODE}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem(keyType)}`
    },
    body: JSON.stringify({})
  });
  return response.data.response_data;
});

export const fetchDamageType = createAsyncThunk('GETDAMAGETYPE', async () => {
  const response = await fetch(`${process.env.REACT_APP_RFS_URL}${GETDAMAGETYPE}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem(keyType)}`
    },
    body: JSON.stringify({})
  });
  return response.data.response_data;
});

export const fetchDestination = createAsyncThunk('GETDESTINATION', async () => {
  const response = await fetch(`${process.env.REACT_APP_RFS_URL}${GETDESTINATION}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem(keyType)}`
    },
    body: JSON.stringify({})
  });
  return response.data.response_data.map(item => ({
    value: item.port_code,
    label: item.port_code,
  }));
});

const apiSlice = createSlice({
  name: 'api',
  initialState: {
    keyType: keyType,
    typeCodes: [],
    contentCodes: [],
    ownerCodes: [],
    condCodes: [],
    damageTypes: [],
    destinations: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTypeCode.fulfilled, (state, action) => {
        state.typeCodes = action.payload;
      })
      .addCase(fetchContentCode.fulfilled, (state, action) => {
        state.contentCodes = action.payload;
      })
      .addCase(fetchOwnerCode.fulfilled, (state, action) => {
        state.ownerCodes = action.payload;
      })
      .addCase(fetchCondCode.fulfilled, (state, action) => {
        state.condCodes = action.payload;
      })
      .addCase(fetchDamageType.fulfilled, (state, action) => {
        state.damageTypes = action.payload;
      })
      .addCase(fetchDestination.fulfilled, (state, action) => {
        state.destinations = action.payload;
      });
  },
});

export default apiSlice.reducer;
